import React from 'react';
import './index.scss';
import { Button } from 'antd';
import { CloseOutlined } from '@ant-design/icons';
import MyCarousel from '@/components/Carousel';
import { useState } from 'react';
import { download } from '&/utils/common';
export default function CarouselDig(props) {
    const { pics } = props;
    const [current, setCurrent] = useState(0);
    const [prev, setPrev] = useState(null);

    if (prev !== props.selectNum) {
        setCurrent(props.selectNum);
        setPrev(props.selectNum);
    }

    const afterChange = current => {
        if (current === 'left') {
            setCurrent(state => {
                if (state > pics.length - 2) {
                    return 0;
                } else {
                    return state + 1;
                }
            });
        } else {
            setCurrent(state => {
                if (state <= 0) {
                    return pics.length - 1;
                } else {
                    return state - 1;
                }
            });
        }
    };

    const settings = { ...props.carouselSeting, onSwipe: afterChange };

    const handleMobileDownload = () => {
        download(1, pics[current].path);
    };

    return (
        <>
            <div
                className="model-cauousel-wrap"
                style={{ display: props.visible ? 'block' : 'none' }}>
                <Button
                    onClick={() => props.handleClose()}
                    type="primary"
                    shape="round"
                    className="model-cauousel-close"
                    icon={<CloseOutlined />}></Button>
                <div className="pic-num">
                    <span className="current">{current + 1}</span>
                    <span className="total">/{pics.length}</span>
                </div>
                <MyCarousel
                    gap={props.gap}
                    selectNum={props.selectNum}
                    pics={props.pics}
                    {...settings}
                    imgWidth={200}
                    btnList={props.btnList}
                    dotsTotalWidth={800}
                />
                <div className="mobile-download" onClick={handleMobileDownload}>
                    <i className={`outlined icon-Download`}></i>
                </div>
            </div>
        </>
    );
}
